<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="props.tooltipText"
        @menuClick="addUserNotes()">
        <DocumentPlusIcon class="w-6 h-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import { DocumentPlusIcon } from '@heroicons/vue/24/outline';
import MenuBase from '@/components/common/menus/MenuBase.vue';

const emit = defineEmits(['toggleColumns'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top'
    },
    theme: {
        type: String,
        default: 'light'
    },
    tooltipText: {
        type: String,
        default: 'Add user notes'
    }
})

const addUserNotes = () => {
    emit('addUserNotes');
}
</script>